import { render, staticRenderFns } from "./FilialMenuTable.vue?vue&type=template&id=0238d6b8&scoped=true&"
import script from "./FilialMenuTable.vue?vue&type=script&lang=js&"
export * from "./FilialMenuTable.vue?vue&type=script&lang=js&"
import style0 from "./FilialMenuTable.vue?vue&type=style&index=0&id=0238d6b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0238d6b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VImg,VTextField,VTooltip})
